import { arraysEqual } from '@SonarCX/utilities'

type MetaVal = {
  key: string
  value: string
  row: string | null
  row_key: string | null
}

const getMetaValue = (meta: MetaVal[], key: string) => {
  const metaVal = meta.find(m => m.key === key)
  return metaVal?.value ?? ''
}

// Check if two meta values are equal, accounts for multiselect ordering
const areEqual = (a: string, b: string) => {
  const aArr = a.split('|').filter(Boolean)
  const bArr = b.split('|').filter(Boolean)
  return arraysEqual(aArr, bArr)
}

const isConditionMet = (
  condition: APICustomFieldConfigOptionCondition,
  meta: MetaVal[]
) => {
  const { field_id, negate, match } = condition
  const metaVal = getMetaValue(meta, field_id)

  // A condition is met if the meta value matches any of the match values
  const someMatch = match.some(m => {
    return areEqual(m, metaVal)
  })

  if (negate) {
    return !someMatch
  }

  return someMatch
}

const isOptionAllowed = (
  option: APICustomFieldConfigOption,
  meta: MetaVal[]
) => {
  const { conditions = [] } = option

  if (conditions.length === 0) {
    return true
  }

  // All conditions must be met for an option to be allowed
  const isAllowed = conditions.every(condition => {
    return isConditionMet(condition, meta)
  })

  return isAllowed
}

export const getFilteredOptions = (
  options: APICustomFieldConfigOption[],
  meta: MetaVal[] = []
) => {
  // Only show options that are allowed
  const filtered = options.filter(option => {
    return isOptionAllowed(option, meta)
  })

  return filtered
}
